import Stakeholders from './stakeholders';

export default Stakeholders;
